module.exports = __webpack_public_path__ + "media/icons/checkmark-in-shield-5079e9b8.png";